import React, { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import Linea from './Linea';
import Barras from './Barras';

const Pea = ({ route, nota, fuente }) => {
    const [key, setKey] = useState('total');

    return (
        <div className='container'>
            <Tabs
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3">
                <Tab eventKey="total" title="Total">
                    <div className='row justify-content-md-center'>
                        <Barras route={route} />
                    </div>
                </Tab>
                <Tab eventKey="sexo" title="Por Sexo">
                    <Linea route={route} />
                </Tab>
            </Tabs>
            <div className='row'>
                <div className='col-lg-8' style={{ textAlign: 'left', fontSize: '12px' }}>
                    <p><strong>Fuente: </strong><i>{fuente}</i></p>
                </div>
                <div className='col-lg-8' style={{ textAlign: 'left', fontSize: '12px' }}>
                    <p><strong>Nota: </strong><i>{nota}</i></p>
                </div>
            </div>
        </div>
    );
}
export default Pea;